module.exports = __webpack_public_path__ + "assets/img/structure-5122a2be.png";